<template>
  <v-card outlined>
    <v-card-title>
      {{ item.name }}
    </v-card-title>
    <v-card-subtitle>
      {{ item.granularity }}
    </v-card-subtitle>
    <v-card-text>
      <div class="segments-container" ref="container">
        <v-tooltip v-for="(segment, i) in segments" :key="i" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="segments"
              v-bind="attrs"
              v-on="on"
              :style="{ backgroundColor: segment.color }"
            ></div>
          </template>
          <span>
            Día: {{ segment.id }}
            <br />
            Code 200: {{ segment.statusOk }}
            <br />
            Bad 500: {{ segment.statusBad }}
          </span>
        </v-tooltip>
      </div>
      <div class="text-caption">{{ days }} days ago</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StatusBar",
  props: {
    item: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      records: [],
      containerWidth: 0,
      days: 0,
    };
  },
  computed: {
    segments() {
      const segments = [];
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      for (let i = 0; i < this.days; i++) {
        const d = new Date(today);
        d.setDate(d.getDate() - i);

        const id = d.toLocaleDateString("es-CL", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });

        segments.push({
          id,
          color: this.getColor(),
          item: null,
        });
      }

      return segments.reverse().map((x) => this.updateSegment(x));
    },
  },

  mounted() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);

    this.fetchStatus();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
  methods: {
    getColor(code) {
      if (code >= 200 && code < 300) return "#4caf50"; // verde
      if (code >= 300 && code < 400) return "#ffeb3b"; // amarillo
      if (code >= 400 && code < 500) return "#f44336"; // rojo
      return "#9e9e9e"; // gris para otros
    },
    updateWidth() {
      this.$nextTick(() => {
        const el = this.$refs.container;
        if (el) {
          this.containerWidth = el.clientWidth;
          this.days = Math.floor(this.containerWidth / 8);
        }
      });
    },
    updateSegment(segment) {
      const item = this.records.find((x) => x.id == segment.id);

      segment.item = null;

      if (item) {
        const { details } = item;
        const last = details[details.length - 1];

        segment.color = this.getColor(last.code);
        segment.item = item;
        segment.statusOk = details.filter(
          (x) => x.code >= 200 && x.code < 300
        ).length;
        segment.statusBad = details.filter(
          (x) => x.code >= 400 && x.code < 500
        ).length;
      }

      return segment;
    },

    async fetchStatus() {
      const resp = await this.$http.get("/status", {
        params: { name: this.name },
      });

      const raw = resp.data
        .map((x) => ({
          ...x,
          id: new Date(x.timestamp)
            .toLocaleDateString("es-CL")
            .replace(/\//g, "-"),
        }))
        .reduce((acc, rec) => {
          const key = rec.id;
          (acc[key] ||= []).push(rec);
          return acc;
        }, {});

      this.records = Object.entries(raw).map(([key, arr]) => ({
        id: key,
        details: arr,
      }));

      this.segments.map((x) => this.updateSegment(x));
    },
  },
};
</script>

<style scoped>
.segments-container {
  display: flex;
  flex-wrap: wrap;
}
.segments {
  background-color: green;
  width: 6px;
  height: 25px;
  border-radius: 4px;
  margin-right: 2px;
  margin-bottom: 2px;
}
</style>
